import styles from "./Chart.module.scss";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { classNames } from "primereact/utils";
import { IChartViewModel } from "./models/chartViewModel";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface ILineGraphProps {
  className?: string;
  data: IChartViewModel | undefined;
}

export const LineChart = ({ className, data }: ILineGraphProps) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top" as const,
      },
    },
  };

  if (!data) {
    return;
  }
  return (
    <div className={classNames(styles.root, className)}>
      <Line className={styles.root_graph} options={options} data={data} />
    </div>
  );
};
